import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 0.4rem;
  max-width: 1250px;
`
export const Submit = styled.button`
  outline-color: #002d63;
  width: 16rem;
  height: 2.5rem;
  border-radius: 4px;
  border: 1px solid #c7c9c7;
  color: #ffffff;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #25a37b')};
  font-weight: bold;
`
